import { createContext, useContext, useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminContext = createContext();

export function AdminProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [password, setPassword] = useState("");

  // Check localStorage on mount
  useEffect(() => {
    const savedPassword = localStorage.getItem("admin_password");
    if (savedPassword) {
      verifyPassword(savedPassword);
    }
  }, []);

  const verifyPassword = async (pwd) => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/verify`, {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("admin:" + pwd),
          "Content-Type": "application/json"
        }
      });
      
      if (response.ok) {
        setIsAdmin(true);
        setPassword(pwd);
        localStorage.setItem("admin_password", pwd);
        return true;
      }
    } catch (error) {
      console.error("Auth error:", error);
    }
    return false;
  };

  const login = async (pwd) => {
    const success = await verifyPassword(pwd);
    return success;
  };

  const logout = () => {
    setIsAdmin(false);
    setPassword("");
    localStorage.removeItem("admin_password");
  };

  const getAuthHeaders = () => ({
    "Authorization": "Basic " + btoa("admin:" + password),
    "Content-Type": "application/json"
  });

  return (
    <AdminContext.Provider value={{ isAdmin, login, logout, password, getAuthHeaders }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
